import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdcuMakerReportsModule from './adcu-maker-reports-module/adcu-maker-reports-module';

const AdcuMakerReports = () => {
  return (
    <Routes>
      <Route index element={<AdcuMakerReportsModule />} />
    </Routes>
  )
}

export default AdcuMakerReports;